import { render } from "./VacantRequestView.vue?vue&type=template&id=1b8a8738&scoped=true"
import script from "./VacantRequestView.vue?vue&type=script&lang=js"
export * from "./VacantRequestView.vue?vue&type=script&lang=js"

import "./VacantRequestView.vue?vue&type=style&index=0&id=1b8a8738&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b8a8738"]])

export default __exports__